export const GoldMedal = ({ className }) => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_d_1691_5806)">
        <path
          d="M4.23828 6.92432L5.30689 7.52734L3.13689 11.201L2.51405 9.8433L4.23828 6.92432Z"
          fill="#CE4444"
        />
        <path
          d="M4.23828 6.92432L3.16967 6.32129L0.99967 9.99494L2.51405 9.8433L4.23828 6.92432Z"
          fill="#983535"
        />
        <path
          d="M5.7627 6.92432L4.69409 7.52734L6.86409 11.201L7.48692 9.8433L5.7627 6.92432Z"
          fill="#983535"
        />
        <path
          d="M5.7627 6.92432L6.8313 6.32129L9.00131 9.99494L7.48692 9.8433L5.7627 6.92432Z"
          fill="#CE4444"
        />
        <path
          d="M4.96777 0.771606C7.01429 0.771606 8.6747 2.39286 8.6748 4.39465C8.6748 6.39653 7.01436 8.01868 4.96777 8.01868C2.92133 8.01852 1.26172 6.39643 1.26172 4.39465C1.26183 2.39296 2.92139 0.771764 4.96777 0.771606Z"
          fill="url(#paint0_linear_1691_5806)"
          stroke="#765C00"
          strokeWidth="0.0554968"
        />
        <ellipse
          cx="4.9675"
          cy="4.39494"
          rx="2.8718"
          ry="2.80692"
          fill="#A88300"
        />
        <mask
          id="mask0_1691_5806"
          maskUnits="userSpaceOnUse"
          x="2"
          y="1"
          width="6"
          height="7"
        >
          <ellipse
            cx="5.1197"
            cy="4.69468"
            rx="2.87849"
            ry="2.81346"
            fill="#C28B37"
          />
        </mask>
        <g mask="url(#mask0_1691_5806)">
          <ellipse
            cx="4.96638"
            cy="4.39524"
            rx="2.87849"
            ry="2.81346"
            fill="#C09525"
          />
        </g>
        <path
          d="M4.98388 2.4375L5.60481 3.6513L6.84667 3.80303L5.99393 4.73766L6.22574 6.07891L4.98388 5.47201L3.74202 6.07891L3.97591 4.73766L3.12109 3.80303L4.36295 3.6513L4.98388 2.4375Z"
          fill="url(#paint1_linear_1691_5806)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1691_5806"
          x="0.956518"
          y="0.699927"
          width="8.69668"
          height="11.1532"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.304371" dy="0.304371" />
          <feGaussianBlur stdDeviation="0.173926" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1691_5806"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1691_5806"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1691_5806"
          x1="4.96807"
          y1="0.79895"
          x2="4.96807"
          y2="7.99074"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC600" />
          <stop offset="1" stopColor="#FFDE69" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1691_5806"
          x1="4.98388"
          y1="2.4375"
          x2="4.98388"
          y2="6.07891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFCDD" />
          <stop offset="1" stopColor="#FFE896" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const RLocked = ({ className, fill = "#BCB7B7" }) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.548 1.76933C4.888 1.30067 5.40133 1 6.16667 1C6.932 1 7.446 1.3 7.78533 1.76933C8.14 2.26 8.33333 2.978 8.33333 3.83333V4.66667H4V3.83333C4 2.978 4.19333 2.26 4.548 1.76933ZM9.33333 4.66667V3.83333C9.33333 2.848 9.11333 1.89933 8.59533 1.18333C8.062 0.445333 7.242 0 6.16667 0C5.09133 0 4.272 0.445333 3.738 1.18333C3.22 1.89933 3 2.848 3 3.83333V4.66667H2.61333C2.25667 4.66667 1.96 4.66667 1.71667 4.68667C1.46333 4.70733 1.226 4.752 1.00133 4.86667C0.656297 5.04245 0.37578 5.32296 0.2 5.668C0.0853333 5.89267 0.04 6.13067 0.02 6.384C-1.86264e-08 6.62667 0 6.924 0 7.28V10.3867C0 10.7433 -1.86264e-08 11.04 0.02 11.2833C0.04 11.5367 0.0853333 11.7747 0.2 11.9993C0.37578 12.3444 0.656297 12.6249 1.00133 12.8007C1.226 12.9153 1.46333 12.96 1.71667 12.9807C1.96 13.0007 2.25667 13.0007 2.61333 13.0007H9.72C10.0767 13.0007 10.3733 13.0007 10.6167 12.9807C10.87 12.96 11.1073 12.9153 11.332 12.8007C11.677 12.6249 11.9576 12.3444 12.1333 11.9993C12.248 11.7747 12.2933 11.5367 12.3133 11.2833C12.3333 11.0407 12.3333 10.7433 12.3333 10.3873V7.28C12.3333 6.924 12.3333 6.62667 12.3133 6.384C12.2933 6.13067 12.248 5.89267 12.1333 5.668C11.9579 5.32317 11.6779 5.04267 11.3333 4.86667C11.108 4.752 10.8707 4.70733 10.6173 4.68667C10.374 4.66667 10.0773 4.66667 9.72067 4.66667H9.33333Z"
        fill={fill}
      />
    </svg>
  );
};

export const GreyedMedal = ({ className, fill = "#BCB7B7" }) => {
  return (
    <svg
      width="34"
      height="65"
      viewBox="0 0 34 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.30566 2.09288C1.30566 0.937014 2.24268 0 3.39854 0H30.7414C31.8972 0 32.8342 0.937014 32.8342 2.09288V6.42237C32.8342 7.57824 31.8972 8.51525 30.7414 8.51525H29.0022V4.04114H5.13771V8.51525H3.39854C2.24268 8.51525 1.30566 7.57824 1.30566 6.42237V2.09288Z"
        fill={fill}
      />
      <path
        d="M1.30566 2.62999C1.30566 1.47412 2.24268 0.537109 3.39854 0.537109H30.7414C31.8972 0.537109 32.8342 1.47412 32.8342 2.62999V6.95948C32.8342 8.11534 31.8972 9.05236 30.7414 9.05236H29.0022V4.57824H5.13771V9.05236H3.39854C2.24268 9.05236 1.30566 8.11534 1.30566 6.95948V2.62999Z"
        fill={fill}
      />
      <path
        d="M5.14355 4.52771H29.003V21.699L17.0733 30.205L5.14355 21.699V4.52771Z"
        fill={fill}
      />
      <mask
        id="mask0_1691_6989"
        maskUnits="userSpaceOnUse"
        x="5"
        y="4"
        width="24"
        height="27"
      >
        <path
          d="M5.14551 4.52759H28.994V21.7017L17.0697 30.2048L5.14551 21.7017V4.52759Z"
          fill={fill}
        />
      </mask>
      <g mask="url(#mask0_1691_6989)">
        <rect
          x="12.5088"
          y="-5.66455"
          width="9.13345"
          height="35.8695"
          fill={fill}
        />
      </g>
      <rect
        x="15.0869"
        y="25.7039"
        width="3.83456"
        height="6.63901"
        rx="1.91728"
        fill={fill}
      />
      <ellipse
        cx="17.0004"
        cy="47.8973"
        rx="16.8295"
        ry="17.1027"
        fill={fill}
      />
      <ellipse
        cx="17.0031"
        cy="47.8982"
        rx="13.1369"
        ry="13.3502"
        fill={fill}
      />
      <mask
        id="mask1_1691_6989"
        maskUnits="userSpaceOnUse"
        x="4"
        y="36"
        width="27"
        height="27"
      >
        <ellipse
          cx="17.7974"
          cy="49.4195"
          rx="13.1675"
          ry="13.3812"
          fill={fill}
        />
      </mask>
      <g mask="url(#mask1_1691_6989)">
        <ellipse
          cx="17.0024"
          cy="47.8977"
          rx="13.1675"
          ry="13.3812"
          fill={fill}
        />
      </g>
      <ellipse cx="17.1797" cy="47.9935" rx="10.8174" ry="10.993" fill={fill} />
      <path
        d="M17.1816 39.1461L19.732 44.4192L24.8329 45.0783L21.3303 49.1385L22.2824 54.9653L17.1816 52.3287L12.0807 54.9653L13.0414 49.1385L9.53027 45.0783L14.6311 44.4192L17.1816 39.1461Z"
        fill={fill}
      />
      <path
        d="M17.3193 39.0797L19.834 44.277L24.8525 44.9264L25.1348 44.9625L24.9492 45.1783L21.4922 49.1842L22.4336 54.941L22.4824 55.2408L22.2119 55.1012L17.1816 52.5006L12.1514 55.1012L11.8799 55.2418L11.9297 54.9401L12.8789 49.1842L9.41406 45.1783L9.22754 44.9625L9.51074 44.9264L14.5283 44.277L17.0439 39.0797L17.1816 38.7946L17.3193 39.0797Z"
        stroke="#A36D1D"
        strokeOpacity="0.2"
        strokeWidth="0.306355"
      />
      <path
        opacity="0.5"
        d="M29.0537 15.2832L5.04445 15.2832L5.04445 4.55836L29.0537 4.55836L29.0537 15.2832Z"
        fill={fill}
      />
    </svg>
  );
};

export const PointIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#5164D1" />
      <circle cx="12" cy="12" r="7" fill="#FFB300" />
      <circle cx="12" cy="12" r="4" fill="#FFD77A" />
    </svg>
  );
};

export const FilledStar = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.9125 11.0529L4.075 7.25292L1 5.05292H4.8L6 1.05292L7.2 5.05292H11L7.925 7.25292L9.0875 11.0529L6 8.70292L2.9125 11.0529Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const EmptyStar = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.96094 5.12518L7.01367 5.30292H10.2207L7.7793 7.04999L7.63379 7.15448L7.68555 7.32635L8.62109 10.383L6.15137 8.50409L6 8.38885L5.84863 8.50409L3.37793 10.383L4.31445 7.32635L4.36621 7.15448L4.2207 7.04999L1.7793 5.30292H4.98633L5.03906 5.12518L6 1.92206L6.96094 5.12518Z"
        stroke="#2741D6"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export const ActiveHome = ({ className }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.17701 27.9999C6.60634 27.9999 5.33301 26.6932 5.33301 25.0799V13.3439C5.33301 12.4572 5.72634 11.6172 6.39967 11.0639L14.2223 4.63988C14.7222 4.22599 15.3507 3.99951 15.9997 3.99951C16.6486 3.99951 17.2772 4.22599 17.777 4.63988L25.5983 11.0639C26.273 11.6172 26.6663 12.4572 26.6663 13.3439V25.0799C26.6663 26.6932 25.393 27.9999 23.8223 27.9999H8.17701Z"
        fill="#2741D6"
        stroke="#2741D6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.667 28V20.6667C12.667 19.9594 12.9479 19.2811 13.448 18.781C13.9481 18.281 14.6264 18 15.3337 18H16.667C17.3742 18 18.0525 18.281 18.5526 18.781C19.0527 19.2811 19.3337 19.9594 19.3337 20.6667V28"
        fill="white"
      />
    </svg>
  );
};

export const Dot = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68627 10.3137 1 7 1C3.68627 1 1 3.68627 1 7C1 10.3137 3.68627 13 7 13Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  );
};

export const Hands = () => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.451 11.0245C12.4935 11.1416 12.5255 11.248 12.5255 11.3757V16.9311C12.5255 17.4632 12.3233 17.9741 11.9614 18.3679L8.99214 21.6138L5.37367 17.9954L6.67206 16.697L9.65197 3.77692C9.71694 3.49266 9.88438 3.24231 10.1223 3.07372C10.3602 2.90513 10.6519 2.83013 10.9416 2.86305C11.2313 2.89598 11.4988 3.03451 11.6928 3.25218C11.8868 3.46986 11.9938 3.75139 11.9933 4.04298V9.32169C11.8198 9.27447 11.641 9.24944 11.4612 9.24719C10.2905 9.24719 9.3327 10.205 9.3327 11.3757V14.5685C9.3327 14.8665 9.56683 15.1006 9.86482 15.1006C10.1628 15.1006 10.397 14.8665 10.397 14.5685V11.3757C10.397 10.7904 10.8759 10.3114 11.4612 10.3114C11.6634 10.3114 11.8337 10.3859 11.9933 10.4817C12.121 10.5562 12.2168 10.652 12.3126 10.7584C12.3445 10.801 12.3765 10.8436 12.3978 10.8968C12.419 10.9394 12.4403 10.9819 12.451 11.0245ZM2.41504 20.954L6.67206 24.1468L7.91724 22.7952L4.24556 19.1235L2.41504 20.954ZM19.4431 16.697L16.4632 3.77692C16.3982 3.49266 16.2308 3.24231 15.9929 3.07372C15.755 2.90513 15.4633 2.83013 15.1736 2.86305C14.8838 2.89598 14.6164 3.03451 14.4224 3.25218C14.2284 3.46986 14.1214 3.75139 14.1218 4.04298V9.32169C14.2921 9.27912 14.473 9.24719 14.654 9.24719C15.8247 9.24719 16.7825 10.205 16.7825 11.3757V14.5685C16.7825 14.8665 16.5483 15.1006 16.2504 15.1006C15.9524 15.1006 15.7182 14.8665 15.7182 14.5685V11.3757C15.7182 10.7904 15.2393 10.3114 14.654 10.3114C14.4518 10.3114 14.2815 10.3859 14.1218 10.4817C13.9941 10.5562 13.8984 10.652 13.8132 10.7584C13.7813 10.801 13.7387 10.8436 13.7174 10.8968C13.6961 10.9394 13.6749 10.9819 13.6642 11.0245C13.6216 11.1416 13.5897 11.248 13.5897 11.3757V16.9311C13.5897 17.4632 13.7919 17.9741 14.1538 18.3679L17.123 21.6138L20.7415 17.9954L19.4431 16.697ZM21.8696 19.1235L18.1979 22.7952L19.4431 24.1468L23.7001 20.954L21.8696 19.1235Z"
        fill="white"
        fillOpacity="0.75"
      />
    </svg>
  );
};

export const Crown = ({ className, fill = "none" }) => {
  return (
    <svg
      width="28"
      height="26"
      viewBox="0 0 28 26"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.29 1.1167C14.5366 1.15388 14.7735 1.23982 14.9863 1.36963V1.37061C15.2587 1.54309 15.4866 1.7775 15.6504 2.05518L15.6631 2.07666L15.6777 2.09717L19.2266 6.93994L19.5654 7.40088L19.9775 7.00342L23.3916 3.70947L23.4248 3.67725L23.4512 3.64014C23.6458 3.36782 23.9091 3.15261 24.2129 3.01611L24.3457 2.9624C24.704 2.8331 25.0934 2.81468 25.4619 2.91064V2.91162C25.8448 3.01613 26.1862 3.23764 26.4365 3.54541V3.54639C26.6807 3.86553 26.8175 4.25402 26.8271 4.65576L26.8281 4.68018L26.8311 4.70361C26.8326 4.71678 26.8326 4.73048 26.8311 4.74365L24.8438 19.6812V19.6841C24.6602 21.1273 23.9556 22.4537 22.8633 23.4146C21.7707 24.3755 20.3643 24.9051 18.9092 24.9028H9.20996L8.9375 24.897C7.67229 24.8398 6.45808 24.3806 5.4707 23.5874L5.2627 23.4126C4.24036 22.5117 3.55936 21.29 3.32812 19.9526L3.28711 19.6841L3.28613 19.6763L1.1709 4.77979C1.16182 4.41409 1.25865 4.05454 1.44922 3.74463L1.53809 3.61279C1.79033 3.27099 2.15072 3.02323 2.56055 2.91162C2.93005 2.8185 3.31923 2.83891 3.67773 2.96826C4.03782 3.09828 4.3511 3.33338 4.57617 3.64307L4.60156 3.67822L4.63379 3.70947L8.04785 7.00342L8.45996 7.40088L8.79883 6.93994L12.3477 2.09717L12.3652 2.07275L12.3799 2.04736C12.4728 1.88307 12.5896 1.73384 12.7266 1.60498L12.8701 1.48291C13.0201 1.36791 13.1866 1.27647 13.3633 1.21143L13.543 1.15576C13.7259 1.10859 13.9145 1.08891 14.1025 1.09814L14.29 1.1167ZM8.73047 17.0591C8.54999 17.0591 8.37034 17.0851 8.19824 17.1372L8.02832 17.1987C7.86133 17.2679 7.70561 17.3608 7.56641 17.4751L7.43359 17.5962C7.30584 17.7239 7.19717 17.8691 7.1123 18.0278L7.03516 18.1909C6.94306 18.4134 6.89648 18.6523 6.89648 18.8931C6.89653 19.0737 6.92236 19.2531 6.97461 19.4253L7.03516 19.5942C7.10433 19.7612 7.19824 19.9169 7.3125 20.0562L7.43359 20.1899C7.56123 20.3175 7.70667 20.4255 7.86523 20.5103L8.02832 20.5874C8.25077 20.6795 8.48971 20.7271 8.73047 20.7271H19.4033C19.8908 20.7271 20.3573 20.5309 20.7002 20.188C21.0437 19.8442 21.2363 19.3781 21.2363 18.8921C21.2363 18.4059 21.044 17.939 20.7002 17.5952C20.3564 17.2514 19.8895 17.0591 19.4033 17.0591H8.73047Z"
        stroke="currentColor"
        strokeOpacity="0.75"
      />
    </svg>
  );
};

export const Live = ({ className }) => {
  return (
    <svg
      width="25"
      height="28"
      viewBox="0 0 25 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.3333 12.6665H19M1 10.4905C1 5.85984 1 3.54384 2.36667 2.10517C3.73333 0.666504 5.93333 0.666504 10.3333 0.666504H14.3333C18.7333 0.666504 20.9333 0.666504 22.3 2.1065C23.6667 3.5425 23.6667 5.8585 23.6667 10.4892V17.5078C23.6667 22.1385 23.6667 24.4545 22.3 25.8932C20.9333 27.3318 18.7333 27.3332 14.3333 27.3332H10.3333C5.93333 27.3332 3.73333 27.3332 2.36667 25.8932C1 24.4572 1 22.1412 1 17.5105V10.4905Z"
        stroke="currentColor"
        strokeOpacity="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66699 13.9998C5.66699 13.9998 6.33366 13.9998 7.00033 15.3332C7.00033 15.3332 9.11766 11.9998 11.0003 11.3332M14.3337 20.6665H19.0003M7.00033 0.666504L7.10966 1.32384C7.37633 2.91984 7.50966 3.7185 8.06966 4.19317C8.62699 4.6665 9.43633 4.6665 11.055 4.6665H13.611C15.2283 4.6665 16.0377 4.6665 16.5977 4.19317C17.1577 3.7185 17.291 2.91984 17.5563 1.32384L17.667 0.666504M7.00033 20.6665H8.33366"
        stroke="currentColor"
        strokeOpacity="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Profile = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.66699 13.833H17.333C18.8664 13.833 20.3414 14.4043 21.4727 15.4287L21.6934 15.6396C22.8498 16.7961 23.5 18.3645 23.5 20C23.5 20.9283 23.131 21.8182 22.4746 22.4746C21.8182 23.131 20.9283 23.5 20 23.5H4C3.07174 23.5 2.18177 23.131 1.52539 22.4746C0.869014 21.8182 0.5 20.9283 0.5 20C0.5 18.4667 1.07138 16.9926 2.0957 15.8613L2.30664 15.6396C3.4631 14.4833 5.03157 13.833 6.66699 13.833ZM12 0.5C13.2017 0.5 14.3575 0.947249 15.2441 1.75L15.418 1.91602C16.3241 2.82233 16.8329 4.0514 16.833 5.33301C16.833 6.61481 16.3243 7.84457 15.418 8.75098C14.5115 9.6574 13.2819 10.167 12 10.167C10.7981 10.167 9.64252 9.71895 8.75586 8.91602L8.58203 8.75098C7.67571 7.84457 7.16699 6.61481 7.16699 5.33301C7.16707 4.13126 7.61412 2.97545 8.41699 2.08887L8.58203 1.91602C9.48846 1.00959 10.7181 0.5 12 0.5Z"
        stroke="currentColor"
        strokeOpacity="0.75"
      />
    </svg>
  );
};

export const InactiveHome = ({ className }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.17701 27.9999C6.60634 27.9999 5.33301 26.6932 5.33301 25.0799V13.3439C5.33301 12.4572 5.72634 11.6172 6.39967 11.0639L14.2223 4.63988C14.7222 4.22599 15.3507 3.99951 15.9997 3.99951C16.6486 3.99951 17.2772 4.22599 17.777 4.63988L25.5983 11.0639C26.273 11.6172 26.6663 12.4572 26.6663 13.3439V25.0799C26.6663 26.6932 25.393 27.9999 23.8223 27.9999H8.17701Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.667 28V20.6667C12.667 19.9594 12.9479 19.2811 13.448 18.781C13.9481 18.281 14.6264 18 15.3337 18H16.667C17.3742 18 18.0525 18.281 18.5526 18.781C19.0527 19.2811 19.3337 19.9594 19.3337 20.6667V28"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIc = ({ className }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M22.5237 22.5599L26.6303 26.6666M25.333 15.3333C25.333 17.9854 24.2794 20.529 22.4041 22.4043C20.5287 24.2797 17.9852 25.3333 15.333 25.3333C12.6808 25.3333 10.1373 24.2797 8.26194 22.4043C6.38658 20.529 5.33301 17.9854 5.33301 15.3333C5.33301 12.6811 6.38658 10.1375 8.26194 8.26218C10.1373 6.38682 12.6808 5.33325 15.333 5.33325C17.9852 5.33325 20.5287 6.38682 22.4041 8.26218C24.2794 10.1375 25.333 12.6811 25.333 15.3333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Achievement = ({ className }) => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.673 11.1999L13.833 11.4534L15.1668 12.6399L14.8468 14.3334L16.4999 13.5334L18.153 14.3334L17.833 12.6399L19.1668 11.4534L17.3268 11.1999L16.4999 9.6665L15.673 11.1999Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 20C20.9186 20 24.5 16.4186 24.5 12C24.5 7.58144 20.9186 4 16.5 4C12.0814 4 8.5 7.58144 8.5 12C8.5 16.4186 12.0814 20 16.5 20Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.207 17.6001C21.0274 18.8066 19.4965 19.6092 17.8332 19.8932L20.5001 26.667L22.5001 24.9998L25.2866 25.2801L22.207 17.6001ZM7.71289 25.3332L10.5001 25.0535L12.5001 26.6663L15.167 19.8932C13.5037 19.6092 11.9728 18.8066 10.7932 17.6001L7.71289 25.3332Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Cog = ({ className }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19.3337 16.0001C19.3337 15.116 18.9825 14.2682 18.3573 13.6431C17.7322 13.0179 16.8844 12.6667 16.0003 12.6667C15.1163 12.6667 14.2684 13.0179 13.6433 13.6431C13.0182 14.2682 12.667 15.116 12.667 16.0001C12.667 16.8841 13.0182 17.732 13.6433 18.3571C14.2684 18.9822 15.1163 19.3334 16.0003 19.3334C16.8844 19.3334 17.7322 18.9822 18.3573 18.3571C18.9825 17.732 19.3337 16.8841 19.3337 16.0001Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3332 6.51991C13.3332 8.43325 10.9306 9.89858 9.23458 8.90925C6.20658 7.27858 3.90658 11.7692 6.58125 13.5706C8.21325 14.5226 8.21458 17.4106 6.58125 18.3639C3.69725 20.1119 6.32925 24.5772 9.23458 23.0119C11.0732 21.9399 13.3346 23.6946 13.3346 25.6199C13.3346 28.8346 18.6412 28.7519 18.6412 25.6199C18.6412 23.6586 20.8679 21.9199 22.7399 23.0119C25.7266 24.6212 28.2972 19.9292 25.3932 18.3639C23.7586 17.4106 23.7599 14.5106 25.3932 13.5586C28.2772 11.8106 25.6466 7.34525 22.7399 8.90925C21.0826 9.87725 18.6426 8.42525 18.6412 6.51991C18.6412 3.10658 13.3346 3.21325 13.3346 6.51991"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const User = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.44444 3.55556C4.44444 2.61256 4.81905 1.70819 5.48584 1.0414C6.15264 0.374602 7.05701 0 8 0C8.94299 0 9.84736 0.374602 10.5142 1.0414C11.181 1.70819 11.5556 2.61256 11.5556 3.55556C11.5556 4.49855 11.181 5.40292 10.5142 6.06971C9.84736 6.73651 8.94299 7.11111 8 7.11111C7.05701 7.11111 6.15264 6.73651 5.48584 6.06971C4.81905 5.40292 4.44444 4.49855 4.44444 3.55556ZM4.44444 8.88889C3.2657 8.88889 2.13524 9.35714 1.30175 10.1906C0.468253 11.0241 0 12.1546 0 13.3333C0 14.0406 0.280952 14.7189 0.781049 15.219C1.28115 15.719 1.95942 16 2.66667 16H13.3333C14.0406 16 14.7189 15.719 15.219 15.219C15.719 14.7189 16 14.0406 16 13.3333C16 12.1546 15.5317 11.0241 14.6983 10.1906C13.8648 9.35714 12.7343 8.88889 11.5556 8.88889H4.44444Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const Verified = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.937 0.676125C11.7781 0.422243 11.5441 0.224216 11.2674 0.109609C10.9907 -0.00499827 10.6851 -0.0304829 10.3933 0.0367031L8.32192 0.512525C8.10964 0.561319 7.88906 0.561319 7.67678 0.512525L5.60542 0.0367031C5.31357 -0.0304829 5.00803 -0.00499827 4.73134 0.109609C4.45465 0.224216 4.22057 0.422243 4.06169 0.676125L2.93269 2.47803C2.81749 2.66237 2.66196 2.8179 2.47764 2.93426L0.67585 4.06333C0.422423 4.22208 0.224698 4.4558 0.110123 4.73203C-0.00445152 5.00827 -0.030194 5.31333 0.0364693 5.60486L0.512261 7.67866C0.560875 7.89058 0.560875 8.11077 0.512261 8.32269L0.0364693 10.3953C-0.030453 10.687 -0.00484016 10.9923 0.109747 11.2688C0.224334 11.5453 0.422204 11.7792 0.67585 11.938L2.47764 13.0671C2.66196 13.1823 2.81749 13.3378 2.93384 13.5222L4.06284 15.3241C4.38771 15.8437 5.00751 16.1006 5.60542 15.9635L7.67678 15.4877C7.88906 15.4389 8.10964 15.4389 8.32192 15.4877L10.3944 15.9635C10.6861 16.0304 10.9914 16.0048 11.2679 15.8902C11.5443 15.7756 11.7782 15.5777 11.937 15.3241L13.066 13.5222C13.1812 13.3378 13.3367 13.1823 13.5211 13.0671L15.324 11.938C15.5777 11.779 15.7754 11.5448 15.8898 11.2681C16.0042 10.9914 16.0295 10.6859 15.9622 10.3942L15.4876 8.32269C15.4388 8.1104 15.4388 7.8898 15.4876 7.67751L15.9634 5.60486C16.0304 5.31328 16.005 5.00806 15.8906 4.7316C15.7762 4.45514 15.5786 4.22116 15.3252 4.06218L13.5222 2.93311C13.3382 2.81769 13.1826 2.66211 13.0672 2.47803L11.937 0.676125ZM11.3575 5.43089C11.4288 5.29986 11.4465 5.14629 11.4068 5.0025C11.3671 4.85872 11.2732 4.73592 11.1449 4.65995C11.0165 4.58398 10.8637 4.56075 10.7186 4.59517C10.5735 4.62958 10.4474 4.71895 10.3668 4.84447L7.35421 9.94371L5.53514 8.20172C5.48118 8.14631 5.41661 8.10233 5.34528 8.07241C5.27395 8.04249 5.19733 8.02725 5.11998 8.02758C5.04263 8.02792 4.96614 8.04383 4.89508 8.07437C4.82401 8.10491 4.75983 8.14945 4.70635 8.20533C4.65287 8.26122 4.61119 8.3273 4.5838 8.39964C4.55641 8.47198 4.54387 8.5491 4.54692 8.62639C4.54998 8.70368 4.56857 8.77957 4.60158 8.84952C4.6346 8.91947 4.68136 8.98206 4.73909 9.03354L7.08233 11.279C7.14505 11.339 7.2205 11.384 7.30305 11.4107C7.38561 11.4374 7.47314 11.4452 7.55909 11.4333C7.64505 11.4215 7.72722 11.3903 7.79947 11.3423C7.87171 11.2942 7.93216 11.2304 7.97631 11.1557L11.3575 5.43089Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const Bell = () => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00098 16C6.87109 16 7.58299 15.2615 7.58299 14.359H4.41896C4.41896 14.7942 4.58563 15.2116 4.88232 15.5194C5.17901 15.8271 5.5814 16 6.00098 16ZM10.747 11.0769V6.97436C10.747 4.45538 9.44978 2.34667 7.18749 1.78872V1.23077C7.18749 0.549744 6.65751 0 6.00098 0C5.34444 0 4.81446 0.549744 4.81446 1.23077V1.78872C2.54426 2.34667 1.25492 4.44718 1.25492 6.97436V11.0769L0.234516 12.1354C-0.26382 12.6523 0.0842244 13.5385 0.788223 13.5385H11.2058C11.9098 13.5385 12.2658 12.6523 11.7674 12.1354L10.747 11.0769Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const Lock = () => {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5625 5.6V4C10.5625 1.76 8.775 0 6.5 0C4.225 0 2.4375 1.76 2.4375 4V5.6C1.05625 5.6 0 6.64 0 8V13.6C0 14.96 1.05625 16 2.4375 16H10.5625C11.9438 16 13 14.96 13 13.6V8C13 6.64 11.9438 5.6 10.5625 5.6ZM4.0625 4C4.0625 2.64 5.11875 1.6 6.5 1.6C7.88125 1.6 8.9375 2.64 8.9375 4V5.6H4.0625V4Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const Key = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.31153 7.37634C3.34046 7.37643 2.39785 7.7043 1.63634 8.30684C0.874834 8.90938 0.339009 9.75132 0.115635 10.6963C-0.10774 11.6413 -0.00558464 12.6341 0.405558 13.5138C0.816701 14.3935 1.51276 15.1087 2.38102 15.5435C3.24928 15.9783 4.2389 16.1074 5.18964 15.9097C6.14038 15.7121 6.99656 15.1993 7.61955 14.4544C8.24254 13.7096 8.59585 12.7762 8.62229 11.8055C8.64872 10.8348 8.34672 9.88366 7.76519 9.106L10.5938 6.27744L11.4168 7.10038C11.6993 7.38291 12.064 7.58495 12.4985 7.50528C12.8574 7.43958 13.1251 7.19483 13.2763 7.05193L13.4381 6.89752C13.7288 6.61828 13.912 6.44252 14.1994 6.39489C14.4195 6.35793 14.6939 6.29304 14.9452 6.13618C15.2298 5.95935 15.4427 5.68766 15.5464 5.36908C15.6582 5.04651 15.648 4.69414 15.5176 4.37859C15.3953 4.07635 15.1801 3.80532 14.9271 3.55319L14.1222 2.74831L15.8347 1.0359C15.9435 0.919131 16.0027 0.764688 15.9999 0.605109C15.9971 0.445529 15.9324 0.293273 15.8196 0.180415C15.7067 0.0675578 15.5545 0.00291156 15.3949 9.59665e-05C15.2353 -0.00271963 15.0808 0.0565152 14.9641 0.165321L6.89376 8.2346C6.14878 7.67624 5.24254 7.37504 4.31153 7.37634Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const Shield = () => {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 16C6.40521 16 6.31719 15.9932 6.23594 15.9797C6.15469 15.9662 6.07344 15.946 5.99219 15.919C4.16406 15.3114 2.70833 14.1875 1.625 12.5472C0.541667 10.907 0 9.14147 0 7.25063V3.42278C0 3.08523 0.0983124 2.78143 0.294937 2.51139C0.491562 2.24135 0.745333 2.04557 1.05625 1.92405L5.93125 0.101266C6.12083 0.0337553 6.31042 0 6.5 0C6.68958 0 6.87917 0.0337553 7.06875 0.101266L11.9437 1.92405C12.2552 2.04557 12.5092 2.24135 12.7059 2.51139C12.9025 2.78143 13.0005 3.08523 13 3.42278V7.25063C13 9.14093 12.4583 10.9065 11.375 12.5472C10.2917 14.188 8.83594 15.3119 7.00781 15.919C6.92656 15.946 6.84531 15.9662 6.76406 15.9797C6.68281 15.9932 6.59479 16 6.5 16Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const Comm = () => {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.30855 10.5345L5.30465 10.5252C5.22619 10.5061 5.14817 10.4853 5.07065 10.4625L5.0648 10.4605C4.32334 10.2419 3.63859 9.8568 3.0602 9.33314C2.4241 8.7576 1.93493 8.03119 1.63534 7.21726C1.33575 6.40333 1.23483 5.52659 1.34139 4.66347C1.44795 3.80036 1.75875 2.97709 2.24668 2.26544C2.73462 1.55379 3.38488 0.975375 4.14077 0.580623C4.89666 0.185871 5.73522 -0.0132292 6.58334 0.000681985C7.43146 0.0145932 8.26339 0.241094 9.00659 0.660434C9.74978 1.07977 10.3817 1.67922 10.8472 2.40651C11.3127 3.1338 11.5977 3.96684 11.6772 4.83301C11.7026 5.10835 11.4822 5.33302 11.2125 5.33302C10.9434 5.33302 10.7283 5.10835 10.6971 4.83367C10.6111 4.07584 10.3316 3.35472 9.88689 2.74318C9.44212 2.13165 8.84784 1.65139 8.1641 1.35096C7.48036 1.05052 6.7314 0.940556 5.99295 1.03218C5.25449 1.1238 4.5527 1.41376 3.95853 1.87275C3.36436 2.33174 2.89886 2.94349 2.6091 3.64616C2.31933 4.34883 2.21557 5.1175 2.30829 5.87449C2.40102 6.63147 2.68695 7.34993 3.13719 7.95724C3.58742 8.56455 4.18599 9.03917 4.8724 9.33314L4.8984 9.34447C5.0284 9.39914 5.16187 9.44736 5.2988 9.48914C5.41385 9.20401 5.62176 8.96863 5.88709 8.82314C6.15241 8.67765 6.45873 8.63105 6.7538 8.6913C7.04888 8.75155 7.31445 8.9149 7.50522 9.15352C7.696 9.39214 7.80018 9.69124 7.8 9.99982C7.80029 10.3063 7.69766 10.6034 7.50938 10.8414C7.32111 11.0793 7.05867 11.2435 6.76624 11.3062C6.47381 11.369 6.16922 11.3265 5.90374 11.186C5.63825 11.0454 5.42807 10.8154 5.30855 10.5345ZM4.66765 11.3825C3.51295 11.0142 2.48911 10.3062 1.72315 9.34647C1.24846 9.4035 0.810726 9.63734 0.493064 10.0036C0.175403 10.3698 -5.8821e-05 10.843 1.47918e-08 11.3332V11.8099C1.47918e-08 14.2886 2.7365 16 6.5 16C10.2635 16 13 14.1946 13 11.8099V11.3332C13 10.8027 12.7946 10.294 12.4289 9.91894C12.0632 9.54386 11.5672 9.33314 11.05 9.33314H8.68075C8.83407 9.85984 8.80119 10.4252 8.58789 10.9294C8.37459 11.4337 7.99457 11.8445 7.51482 12.0895C7.03507 12.3345 6.4864 12.3979 5.96553 12.2686C5.44465 12.1393 4.98502 11.8255 4.66765 11.3825ZM9.75 5.33302C9.75 4.32499 9.3145 3.42163 8.62485 2.81028C8.27882 2.50411 7.87373 2.27624 7.43602 2.14153C6.99831 2.00682 6.53782 1.9683 6.08461 2.02849C5.6314 2.08869 5.19567 2.24623 4.80585 2.49085C4.41602 2.73547 4.08088 3.06166 3.8223 3.44813C3.56371 3.8346 3.3875 4.27266 3.30516 4.73371C3.22282 5.19476 3.2362 5.66844 3.34444 6.12383C3.45267 6.57921 3.65333 7.00607 3.9333 7.37653C4.21327 7.74699 4.56627 8.05272 4.96925 8.27377C5.38804 7.88302 5.93384 7.66646 6.5 7.66642C7.06638 7.66629 7.61244 7.88286 8.0314 8.27377C8.5507 7.98923 8.98488 7.56535 9.28758 7.0474C9.59027 6.52945 9.7501 5.93689 9.75 5.33302Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const Bricked = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4919 2.54381C11.4919 1.86915 11.2279 1.22212 10.7579 0.745064C10.2879 0.268007 9.65055 0 8.98594 0C8.32132 0 7.68393 0.268007 7.21397 0.745064C6.74402 1.22212 6.48 1.86915 6.48 2.54381C6.48 3.21847 6.74402 3.86549 7.21397 4.34255C7.68393 4.81961 8.32132 5.08761 8.98594 5.08761C9.65055 5.08761 10.2879 4.81961 10.7579 4.34255C11.2279 3.86549 11.4919 3.21847 11.4919 2.54381ZM0.579375 10.29H3.94313V6.87998L3.95213 6.67442C3.98137 6.33525 4.08487 6.01777 4.24462 5.73798H1.143L1.01137 5.74598C0.737717 5.7787 0.485409 5.91224 0.302305 6.12127C0.1192 6.3303 0.0180364 6.60027 0.018 6.87998V9.719C0.018 9.87044 0.0772631 10.0157 0.182752 10.1228C0.288242 10.2298 0.430191 10.29 0.579375 10.29ZM17.9899 9.719C17.9899 9.87044 17.9306 10.0157 17.8251 10.1228C17.7196 10.2298 17.5766 10.29 17.4274 10.29H14.0344V6.87998L14.0276 6.70982C14.0026 6.36751 13.9018 6.03533 13.7329 5.73798H16.8649C17.1406 5.73805 17.4067 5.84091 17.6126 6.02701C17.8186 6.21311 17.95 6.46951 17.982 6.74751L17.9899 6.87998V9.719ZM12.9015 6.74751C12.8695 6.46932 12.7379 6.21276 12.5317 6.02663C12.3255 5.8405 12.0592 5.73777 11.7832 5.73798H6.19425L6.06262 5.74598C5.78897 5.7787 5.53666 5.91224 5.35355 6.12127C5.17045 6.3303 5.06929 6.60027 5.06925 6.87998V10.29H12.9094V6.87998L12.9015 6.74751ZM14.598 0.717747C15.1688 0.717747 15.7162 0.947915 16.1198 1.35762C16.5234 1.76732 16.7501 2.32299 16.7501 2.90239C16.7501 3.4818 16.5234 4.03747 16.1198 4.44717C15.7162 4.85687 15.1688 5.08704 14.598 5.08704C14.0271 5.08704 13.4795 4.85681 13.0758 4.44701C12.6721 4.0372 12.4453 3.48138 12.4453 2.90182C12.4453 2.32227 12.6721 1.76645 13.0758 1.35664C13.4795 0.946833 14.0271 0.717747 14.598 0.717747ZM5.54513 2.90125C5.54513 2.32185 5.31838 1.76617 4.91478 1.35647C4.51118 0.946773 3.96378 0.716605 3.393 0.716605C2.82222 0.716605 2.27482 0.946773 1.87122 1.35647C1.46762 1.76617 1.24087 2.32185 1.24087 2.90125C1.24087 3.48066 1.46762 4.03633 1.87122 4.44603C2.27482 4.85573 2.82222 5.0859 3.393 5.0859C3.96378 5.0859 4.51118 4.85573 4.91478 4.44603C5.31838 4.03633 5.54513 3.48066 5.54513 2.90125ZM0.5625 11.432C0.413316 11.432 0.270242 11.4922 0.164753 11.5992C0.0592633 11.7063 0 11.8516 0 12.003V13.145C0 13.9022 0.296316 14.6284 0.823762 15.1638C1.35121 15.6992 2.06658 16 2.8125 16H15.1875C15.9334 16 16.6488 15.6992 17.1762 15.1638C17.7037 14.6284 18 13.9022 18 13.145V12.003C18 11.8516 17.9407 11.7063 17.8352 11.5992C17.7298 11.4922 17.5867 11.432 17.4375 11.432H0.5625Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const Exit = ({ className }) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1731_5334)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2.10714C0 1.6809 0.169323 1.27212 0.470721 0.970721C0.772119 0.669323 1.1809 0.5 1.60714 0.5L9.10714 0.5C9.53338 0.5 9.94217 0.669323 10.2436 0.970721C10.545 1.27212 10.7143 1.6809 10.7143 2.10714V4.18464C10.2796 4.53285 9.99748 5.03666 9.92786 5.58929H6.16071C5.84414 5.58929 5.53066 5.65164 5.23817 5.77279C4.94569 5.89394 4.67994 6.07151 4.45608 6.29537C4.23223 6.51922 4.05465 6.78498 3.93351 7.07746C3.81236 7.36994 3.75 7.68342 3.75 8C3.75 8.31658 3.81236 8.63006 3.93351 8.92254C4.05465 9.21502 4.23223 9.48078 4.45608 9.70463C4.67994 9.92849 4.94569 10.1061 5.23817 10.2272C5.53066 10.3484 5.84414 10.4107 6.16071 10.4107H9.92786C9.99748 10.9633 10.2796 11.4671 10.7143 11.8154V13.8929C10.7143 14.3191 10.545 14.7279 10.2436 15.0293C9.94217 15.3307 9.53338 15.5 9.10714 15.5H1.60714C1.1809 15.5 0.772119 15.3307 0.470721 15.0293C0.169323 14.7279 0 14.3191 0 13.8929L0 2.10714ZM11.7461 5.11464C11.5992 5.17547 11.4737 5.27848 11.3854 5.41064C11.2971 5.54281 11.25 5.69819 11.25 5.85714V6.92857H6.16071C5.87655 6.92857 5.60403 7.04145 5.4031 7.24239C5.20217 7.44332 5.08929 7.71584 5.08929 8C5.08929 8.28416 5.20217 8.55668 5.4031 8.75761C5.60403 8.95855 5.87655 9.07143 6.16071 9.07143H11.25V10.1429C11.2501 10.3017 11.2973 10.4569 11.3857 10.5889C11.474 10.7209 11.5994 10.8238 11.7462 10.8846C11.8929 10.9454 12.0544 10.9613 12.2101 10.9303C12.3659 10.8994 12.5091 10.823 12.6214 10.7107L14.7643 8.56786C14.9148 8.41719 14.9993 8.21295 14.9993 8C14.9993 7.78705 14.9148 7.58281 14.7643 7.43214L12.6214 5.28929C12.5091 5.1769 12.366 5.10033 12.2102 5.06924C12.0544 5.03816 11.8929 5.05396 11.7461 5.11464Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1731_5334">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Silver = ({ className }) => {
  return (
    <svg
      className={className}
      width="18"
      height="23"
      viewBox="0 0 18 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1691_6205)">
        <path
          d="M6.50781 13.0398L8.55983 14.2245L4.39284 21.442L3.19682 18.7746L6.50781 13.0398Z"
          fill="#418ED6"
        />
        <path
          d="M6.50781 13.0398L4.45579 11.8551L0.288797 19.0725L3.19682 18.7746L6.50781 13.0398Z"
          fill="#2B63A6"
        />
        <path
          d="M9.43652 13.0398L7.3845 14.2245L11.5515 21.442L12.7475 18.7746L9.43652 13.0398Z"
          fill="#2B63A6"
        />
        <path
          d="M9.43652 13.0398L11.4885 11.8551L15.6555 19.0725L12.7475 18.7746L9.43652 13.0398Z"
          fill="#418ED6"
        />
        <circle
          cx="7.969"
          cy="8.07081"
          r="7.12694"
          fill="#E3E3E3"
          stroke="#404040"
          strokeWidth="0.12448"
        />
        <circle cx="7.96972" cy="8.07043" r="5.51464" fill="#595959" />
        <mask
          id="mask0_1691_6205"
          maskUnits="userSpaceOnUse"
          x="2"
          y="3"
          width="12"
          height="12"
        >
          <circle cx="8.26283" cy="8.65943" r="5.52748" fill="#C28B37" />
        </mask>
        <g mask="url(#mask0_1691_6205)">
          <circle
            cx="7.97083"
            cy="8.07044"
            r="5.52748"
            fill="url(#paint0_linear_1691_6205)"
          />
        </g>
        <path
          d="M8.00089 4.22522L9.19325 6.60993L11.578 6.90802L9.94046 8.74424L10.3856 11.3793L8.00089 10.187L5.61618 11.3793L6.0653 8.74424L4.42383 6.90802L6.80854 6.60993L8.00089 4.22522Z"
          fill="url(#paint1_linear_1691_6205)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1691_6205"
          x="0.191533"
          y="0.784062"
          width="16.9267"
          height="22.1209"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.682706" dy="0.682706" />
          <feGaussianBlur stdDeviation="0.390118" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1691_6205"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1691_6205"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1691_6205"
          x1="7.97083"
          y1="2.54297"
          x2="7.97083"
          y2="13.5979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9CA1A3" />
          <stop offset="1" stopColor="#9CA1A3" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1691_6205"
          x1="8.00089"
          y1="4.22522"
          x2="8.00089"
          y2="11.3793"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F5F5" />
          <stop offset="0.0001" stopColor="white" />
          <stop offset="1" stopColor="#F1F5F5" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Bronze = ({ className }) => {
  return (
    <svg
      width="18"
      height="23"
      viewBox="0 0 18 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_d_1691_6216)">
        <path
          d="M7.08105 13.0398L9.13307 14.2245L4.96608 21.442L3.77006 18.7746L7.08105 13.0398Z"
          fill="#AA75CB"
        />
        <path
          d="M7.08105 13.0398L5.02904 11.8551L0.862039 19.0725L3.77006 18.7746L7.08105 13.0398Z"
          fill="#73488D"
        />
        <path
          d="M10.0049 13.0398L7.95286 14.2245L12.1199 21.442L13.3159 18.7746L10.0049 13.0398Z"
          fill="#73488D"
        />
        <path
          d="M10.0049 13.0398L12.0569 11.8551L16.2239 19.0725L13.3159 18.7746L10.0049 13.0398Z"
          fill="#AA75CB"
        />
        <circle
          cx="8.54224"
          cy="8.07081"
          r="7.12694"
          fill="#DC9E42"
          stroke="#774700"
          strokeWidth="0.12448"
        />
        <circle cx="8.54296" cy="8.07043" r="5.51464" fill="#734C12" />
        <mask
          id="mask0_1691_6216"
          maskUnits="userSpaceOnUse"
          x="3"
          y="3"
          width="12"
          height="12"
        >
          <circle cx="8.83705" cy="8.65931" r="5.52748" fill="#C28B37" />
        </mask>
        <g mask="url(#mask0_1691_6216)">
          <circle cx="8.54115" cy="8.07044" r="5.52748" fill="#A36D1D" />
        </g>
        <path
          d="M8.56925 4.22522L9.76161 6.60993L12.1463 6.90802L10.5088 8.74424L10.954 11.3793L8.56925 10.187L6.18454 11.3793L6.63366 8.74424L4.99219 6.90802L7.3769 6.60993L8.56925 4.22522Z"
          fill="url(#paint0_linear_1691_6216)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1691_6216"
          x="0.764775"
          y="0.784062"
          width="16.9218"
          height="22.1209"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.682706" dy="0.682706" />
          <feGaussianBlur stdDeviation="0.390118" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1691_6216"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1691_6216"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1691_6216"
          x1="8.56925"
          y1="4.22522"
          x2="8.56925"
          y2="11.3793"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCFF80" />
          <stop offset="0.401042" stopColor="#FDE870" />
          <stop offset="1" stopColor="#FFC759" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Time = ({ color = "#FFD700", bgColor = "#534D26" }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="5" fill={bgColor} />
      <path
        d="M16.5 13.5V19.5H21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 18C27 19.1819 26.7672 20.3522 26.3149 21.4442C25.8626 22.5361 25.1997 23.5282 24.364 24.364C23.5282 25.1997 22.5361 25.8626 21.4442 26.3149C20.3522 26.7672 19.1819 27 18 27C16.8181 27 15.6478 26.7672 14.5558 26.3149C13.4639 25.8626 12.4718 25.1997 11.636 24.364C10.8003 23.5282 10.1374 22.5361 9.68508 21.4442C9.23279 20.3522 9 19.1819 9 18C9 15.6131 9.94821 13.3239 11.636 11.636C13.3239 9.94821 15.6131 9 18 9C20.3869 9 22.6761 9.94821 24.364 11.636C26.0518 13.3239 27 15.6131 27 18Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Scoring = ({ color = "#FFD700", bgColor = "#534D26" }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="5" fill={bgColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.802 10.821C13.761 10.859 13.75 10.896 13.75 10.923V16.461C13.75 17.861 14.136 19.061 14.833 19.898C15.516 20.716 16.548 21.25 18 21.25C19.452 21.25 20.484 20.716 21.167 19.898C21.864 19.062 22.25 17.861 22.25 16.461V10.923C22.25 10.896 22.24 10.859 22.198 10.821C22.1427 10.7742 22.0724 10.749 22 10.75H14C13.9276 10.749 13.8573 10.7742 13.802 10.821ZM12.25 10.923C12.25 9.943 13.091 9.25 14 9.25H22C22.909 9.25 23.75 9.944 23.75 10.923V11.25H25C25.966 11.25 26.75 12.034 26.75 13V15C26.75 16.908 25.223 18.421 23.443 18.703C23.2193 19.4905 22.8368 20.2239 22.319 20.858C21.466 21.88 20.259 22.546 18.75 22.71V25.25H21C21.1989 25.25 21.3897 25.329 21.5303 25.4697C21.671 25.6103 21.75 25.8011 21.75 26C21.75 26.1989 21.671 26.3897 21.5303 26.5303C21.3897 26.671 21.1989 26.75 21 26.75H15C14.8011 26.75 14.6103 26.671 14.4697 26.5303C14.329 26.3897 14.25 26.1989 14.25 26C14.25 25.8011 14.329 25.6103 14.4697 25.4697C14.6103 25.329 14.8011 25.25 15 25.25H17.25V22.71C15.741 22.545 14.534 21.88 13.681 20.858C13.1632 20.2239 12.7807 19.4905 12.557 18.703C10.777 18.42 9.25 16.908 9.25 15V13C9.25 12.034 10.034 11.25 11 11.25H12.25V10.923ZM12.25 12.75H11C10.9337 12.75 10.8701 12.7763 10.8232 12.8232C10.7763 12.8701 10.75 12.9337 10.75 13V15C10.75 15.91 11.394 16.738 12.272 17.082C12.2575 16.8756 12.2502 16.6689 12.25 16.462V12.75ZM23.728 17.082C24.606 16.738 25.25 15.91 25.25 15V13C25.25 12.9337 25.2237 12.8701 25.1768 12.8232C25.1299 12.7763 25.0663 12.75 25 12.75H23.75V16.461C23.75 16.6697 23.7427 16.8767 23.728 17.082Z"
        fill={color}
      />
    </svg>
  );
};

export const Users = ({ color = "#FFD700", bgColor = "#534D26" }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="5" fill={bgColor} />
      <path
        d="M27 25.5C27 23.41 25.33 20.432 23 19.773M21 25.5C21 22.849 18.314 19.5 15 19.5C11.686 19.5 9 22.849 9 25.5M21 16C21.7956 16 22.5587 15.6839 23.1213 15.1213C23.6839 14.5587 24 13.7956 24 13C24 12.2044 23.6839 11.4413 23.1213 10.8787C22.5587 10.3161 21.7956 10 21 10M18 13C18 13.7956 17.6839 14.5587 17.1213 15.1213C16.5587 15.6839 15.7956 16 15 16C14.2044 16 13.4413 15.6839 12.8787 15.1213C12.3161 14.5587 12 13.7956 12 13C12 12.2044 12.3161 11.4413 12.8787 10.8787C13.4413 10.3161 14.2044 10 15 10C15.7956 10 16.5587 10.3161 17.1213 10.8787C17.6839 11.4413 18 12.2044 18 13Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Gold = ({ className }) => {
  return (
    <svg
      className={className}
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1691_6227)">
        <path
          d="M6.64746 13.0405L8.69948 14.2253L4.53248 21.4427L3.33647 18.7753L6.64746 13.0405Z"
          fill="#CE4444"
        />
        <path
          d="M6.64746 13.0405L4.59544 11.8558L0.428446 19.0732L3.33647 18.7753L6.64746 13.0405Z"
          fill="#983535"
        />
        <path
          d="M9.57617 13.0405L7.52415 14.2253L11.6911 21.4427L12.8872 18.7753L9.57617 13.0405Z"
          fill="#983535"
        />
        <path
          d="M9.57617 13.0405L11.6282 11.8558L15.7952 19.0732L12.8872 18.7753L9.57617 13.0405Z"
          fill="#CE4444"
        />
        <circle
          cx="8.05005"
          cy="8.07007"
          r="7.12694"
          fill="url(#paint0_linear_1691_6227)"
          stroke="#765C00"
          strokeWidth="0.12448"
        />
        <circle cx="8.04784" cy="8.07079" r="5.51464" fill="#A88300" />
        <mask
          id="mask0_1691_6227"
          maskUnits="userSpaceOnUse"
          x="2"
          y="3"
          width="12"
          height="12"
        >
          <circle cx="8.34193" cy="8.65907" r="5.52748" fill="#C28B37" />
        </mask>
        <g mask="url(#mask0_1691_6227)">
          <circle cx="8.04798" cy="8.07008" r="5.52748" fill="#C09525" />
        </g>
        <path
          d="M8.07999 4.22546L9.27235 6.61017L11.6571 6.90826L10.0196 8.74449L10.4647 11.3796L8.07999 10.1872L5.69528 11.3796L6.1444 8.74449L4.50293 6.90826L6.88764 6.61017L8.07999 4.22546Z"
          fill="url(#paint1_linear_1691_6227)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1691_6227"
          x="0.323054"
          y="0.775203"
          width="17.0567"
          height="22.2524"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.739598" dy="0.739598" />
          <feGaussianBlur stdDeviation="0.422627" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1691_6227"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1691_6227"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1691_6227"
          x1="8.05005"
          y1="1.00537"
          x2="8.05005"
          y2="15.1348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC600" />
          <stop offset="1" stopColor="#FFDE69" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1691_6227"
          x1="8.07999"
          y1="4.22546"
          x2="8.07999"
          y2="11.3796"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFCDD" />
          <stop offset="1" stopColor="#FFE896" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BlueMedal = () => {
  return (
    <svg
      width="16"
      height="29"
      viewBox="0 0 16 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1691_6239)">
        <path
          d="M0.904297 1.85625C0.904297 1.38659 1.28503 1.00586 1.75469 1.00586H12.8648C13.3344 1.00586 13.7151 1.38659 13.7151 1.85625V3.56016C13.7151 4.02981 13.3344 4.41054 12.8648 4.41054H12.1581V2.62164H2.46135V4.41054H1.75469C1.28503 4.41054 0.904297 4.02981 0.904297 3.56016V1.85625Z"
          fill="#FFEEB0"
        />
        <path
          d="M0.904297 2.07085C0.904297 1.60119 1.28503 1.22046 1.75469 1.22046H12.8648C13.3344 1.22046 13.7151 1.60119 13.7151 2.07085V3.77476C13.7151 4.24441 13.3344 4.62514 12.8648 4.62514H12.1581V2.83624H2.46135V4.62514H1.75469C1.28503 4.62514 0.904297 4.24441 0.904297 3.77476V2.07085Z"
          fill="#F4CC3F"
        />
        <path
          d="M2.45996 2.81519H12.1547V9.68085L7.30731 13.0818L2.45996 9.68085V2.81519Z"
          fill="#2874BA"
        />
        <mask
          id="mask0_1691_6239"
          maskUnits="userSpaceOnUse"
          x="2"
          y="2"
          width="11"
          height="12"
        >
          <path
            d="M2.48047 2.81519H12.1707V9.68198L7.32557 13.0818L2.48047 9.68198V2.81519Z"
            fill="#2874BA"
          />
        </mask>
        <g mask="url(#mask0_1691_6239)">
          <rect
            x="5.4707"
            y="-1.25989"
            width="3.71114"
            height="14.3418"
            fill="#2D4071"
          />
        </g>
        <rect
          x="6.5"
          y="11.2826"
          width="1.55808"
          height="2.6545"
          rx="0.779038"
          fill="#C09525"
        />
        <circle
          cx="7.27963"
          cy="20.1563"
          r="6.83822"
          fill="url(#paint0_linear_1691_6239)"
        />
        <circle cx="7.27828" cy="20.1568" r="5.33785" fill="#705100" />
        <mask
          id="mask1_1691_6239"
          maskUnits="userSpaceOnUse"
          x="2"
          y="15"
          width="11"
          height="12"
        >
          <circle cx="7.60028" cy="20.7647" r="5.35028" fill="#C28B37" />
        </mask>
        <g mask="url(#mask1_1691_6239)">
          <circle cx="7.27996" cy="20.1561" r="5.35028" fill="#E3A504" />
        </g>
        <circle cx="7.35142" cy="20.1955" r="4.39536" fill="#C18222" />
        <path
          d="M7.35012 16.6576L8.38643 18.7659L10.459 19.0295L9.03585 20.6529L9.42273 22.9826L7.35012 21.9285L5.27752 22.9826L5.66786 20.6529L4.24121 19.0295L6.31382 18.7659L7.35012 16.6576Z"
          fill="url(#paint1_linear_1691_6239)"
        />
        <path
          d="M7.40625 16.6302L8.42676 18.7084L10.4668 18.9681L10.583 18.9828L10.5059 19.0707L9.10156 20.6713L9.48438 22.972L9.50391 23.0941L9.39453 23.0385L7.34961 21.9974L5.30566 23.0385L5.19531 23.0941L5.21582 22.972L5.60156 20.6713L4.19434 19.0707L4.11719 18.9828L4.2334 18.9681L6.27246 18.7084L7.29395 16.6302L7.35059 16.517L7.40625 16.6302Z"
          stroke="#A36D1D"
          strokeOpacity="0.2"
          strokeWidth="0.12448"
        />
        <path
          opacity="0.5"
          d="M12.2031 7.11609L2.44757 7.11609L2.44757 2.82793L12.2031 2.82793L12.2031 7.11609Z"
          fill="url(#paint2_linear_1691_6239)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1691_6239"
          x="0.343877"
          y="0.90833"
          width="15.2372"
          height="27.5491"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.682706" dy="0.682706" />
          <feGaussianBlur stdDeviation="0.390118" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1691_6239"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1691_6239"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1691_6239"
          x1="7.27963"
          y1="13.3181"
          x2="7.27963"
          y2="26.9946"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE176" />
          <stop offset="1" stopColor="#FFD12D" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1691_6239"
          x1="7.35012"
          y1="16.6576"
          x2="7.35012"
          y2="22.9826"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.0001" stopColor="#FFFFFD" />
          <stop offset="1" stopColor="#FFE86D" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1691_6239"
          x1="7.32535"
          y1="7.11609"
          x2="7.32535"
          y2="2.82793"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D62A2" stopOpacity="0" />
          <stop offset="1" stopColor="#14275A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const SeurityShield = ({ className }) => {
  return (
    <svg
      className={className}
      width="800px"
      height="800px"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="customGradient" x1="0" y1="0" x2="0" y2="1">
          <stop offset="20%" stopColor="#2a43d1" />
          <stop offset="100%" stopColor="#094eff" />
        </linearGradient>
      </defs>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16L4.35009 13.3929C2.24773 11.8912 1 9.46667 1 6.88306V3L8 0L15 3V6.88306C15 9.46667 13.7523 11.8912 11.6499 13.3929L8 16ZM12.2071 5.70711L10.7929 4.29289L7 8.08579L5.20711 6.29289L3.79289 7.70711L7 10.9142L12.2071 5.70711Z"
        fill="url(#customGradient)"
      />
    </svg>
  );
};

export const CheveronRight = ({ className, stroke = "black" }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1L0.999999 9L9 17"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckedCircle = () => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.5 36.6917L52.3417 53.1083C52.6663 53.4612 53.0642 53.7386 53.5075 53.9212C53.9508 54.1038 54.4287 54.1871 54.9076 54.1653C55.3865 54.1435 55.8549 54.017 56.2797 53.7948C56.7045 53.5726 57.0755 53.2601 57.3667 52.8792L87.5 12.5"
        stroke="#2741D6"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M87.5 50C87.5 57.4168 85.3007 64.667 81.1801 70.8339C77.0596 77.0007 71.2029 81.8072 64.3506 84.6455C57.4984 87.4838 49.9584 88.2264 42.6841 86.7794C35.4098 85.3325 28.728 81.761 23.4835 76.5165C18.239 71.272 14.6675 64.5902 13.2206 57.3159C11.7736 50.0416 12.5162 42.5016 15.3545 35.6494C18.1928 28.7971 22.9993 22.9404 29.1661 18.8199C35.333 14.6993 42.5832 12.5 50 12.5"
        stroke="#2741D6"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CircledCheveron = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#094EFF" fillOpacity="0.2" />
      <path
        d="M10 16.3126L14.3126 12L10 7.68742"
        stroke="#2741D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
// RMC

export const RMCCrown = ({ fill = "#FFD700" }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9994 4.00012C12.9994 4.53012 12.7934 5.01212 12.4564 5.37012L15.0804 8.65012C15.1161 8.69488 15.166 8.72605 15.2219 8.73842C15.2778 8.7508 15.3362 8.74363 15.3874 8.71812L18.0374 7.39212C17.9802 7.10199 17.9878 6.80279 18.0599 6.51598C18.1319 6.22916 18.2665 5.96184 18.454 5.7332C18.6416 5.50455 18.8774 5.32025 19.1446 5.1935C19.4118 5.06676 19.7037 5.00072 19.9994 5.00012C20.4911 5.00022 20.9655 5.18143 21.3321 5.50914C21.6986 5.83686 21.9316 6.28811 21.9865 6.77671C22.0414 7.26531 21.9144 7.75703 21.6298 8.15794C21.3451 8.55885 20.9228 8.84086 20.4434 8.95012L18.6394 18.5731C18.5641 18.9742 18.351 19.3364 18.0369 19.5969C17.7228 19.8575 17.3275 20.0001 16.9194 20.0001H5.07942C4.67131 20.0001 4.27604 19.8575 3.96196 19.5969C3.64788 19.3364 3.43474 18.9742 3.35942 18.5731L1.55542 8.95012C1.17203 8.8627 0.822912 8.66421 0.551721 8.37946C0.280531 8.09471 0.0992981 7.73633 0.0306835 7.34914C-0.0379311 6.96194 0.00911684 6.56311 0.165945 6.20251C0.322773 5.84191 0.582422 5.53554 0.912428 5.32171C1.24243 5.10788 1.62815 4.99607 2.02136 5.00027C2.41456 5.00447 2.79781 5.12449 3.12317 5.34532C3.44854 5.56615 3.70158 5.87799 3.85067 6.24186C3.99976 6.60573 4.03828 7.00547 3.96142 7.39112L6.61142 8.71712C6.66264 8.74263 6.72107 8.7498 6.77695 8.73742C6.83282 8.72505 6.88276 8.69388 6.91842 8.64912L9.54242 5.36912C9.31885 5.13137 9.15686 4.84253 9.07058 4.52779C8.9843 4.21306 8.97635 3.88199 9.04742 3.56347C9.11849 3.24496 9.26642 2.94867 9.47832 2.70047C9.69021 2.45226 9.95962 2.25968 10.263 2.13952C10.5665 2.01936 10.8947 1.97528 11.2191 2.01112C11.5434 2.04696 11.8541 2.16163 12.124 2.34513C12.3939 2.52863 12.6147 2.77538 12.7673 3.06386C12.9199 3.35233 12.9996 3.67377 12.9994 4.00012ZM10.9994 16.0001C11.5298 16.0001 12.0386 15.7894 12.4136 15.4143C12.7887 15.0393 12.9994 14.5305 12.9994 14.0001C12.9994 13.4697 12.7887 12.961 12.4136 12.5859C12.0386 12.2108 11.5298 12.0001 10.9994 12.0001C10.469 12.0001 9.96028 12.2108 9.5852 12.5859C9.21013 12.961 8.99942 13.4697 8.99942 14.0001C8.99942 14.5305 9.21013 15.0393 9.5852 15.4143C9.96028 15.7894 10.469 16.0001 10.9994 16.0001Z"
        fill={fill}
      />
    </svg>
  );
};

export const Wifi = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.6449 13.6595C21.5596 6.94487 10.4396 6.94487 3.35423 13.6595C3.25889 13.7499 3.14668 13.8206 3.02403 13.8676C2.90137 13.9145 2.77066 13.9369 2.63936 13.9334C2.50805 13.9299 2.37873 13.9005 2.25878 13.847C2.13882 13.7935 2.03058 13.7169 1.94023 13.6215C1.84988 13.5262 1.77919 13.414 1.7322 13.2913C1.68522 13.1687 1.66285 13.038 1.66638 12.9067C1.6735 12.6415 1.78568 12.39 1.97823 12.2075C9.83556 4.7622 22.1649 4.7622 30.0209 12.2075C30.2136 12.39 30.326 12.6416 30.3332 12.9069C30.3405 13.1722 30.242 13.4295 30.0596 13.6222C29.8771 13.8149 29.6255 13.9273 29.3602 13.9345C29.0949 13.9418 28.8376 13.842 28.6449 13.6595ZM5.95956 16.7835C11.5049 11.2382 20.4942 11.2382 26.0396 16.7835C26.2162 16.9731 26.3124 17.2238 26.3078 17.4829C26.3032 17.742 26.1983 17.9891 26.0151 18.1724C25.8318 18.3556 25.5847 18.4605 25.3256 18.4651C25.0665 18.4697 24.8158 18.3735 24.6262 18.1969C22.3383 15.9089 19.2352 14.6236 15.9996 14.6236C12.7639 14.6236 9.66083 15.9089 7.37289 18.1969C7.28134 18.2951 7.17094 18.3739 7.04828 18.4286C6.92561 18.4832 6.79319 18.5126 6.65892 18.515C6.52465 18.5174 6.39128 18.4927 6.26676 18.4424C6.14224 18.3921 6.02913 18.3172 5.93417 18.2223C5.83922 18.1273 5.76436 18.0142 5.71406 17.8897C5.66377 17.7651 5.63907 17.6318 5.64144 17.4975C5.64381 17.3632 5.67319 17.2308 5.72785 17.1082C5.78251 16.9855 5.86131 16.8751 5.95956 16.7835ZM9.95956 21.1275C11.5616 19.5258 13.7342 18.626 15.9996 18.626C18.2649 18.626 20.4375 19.5258 22.0396 21.1275C22.2162 21.3171 22.3124 21.5678 22.3078 21.8269C22.3032 22.086 22.1983 22.3331 22.0151 22.5164C21.8318 22.6996 21.5847 22.8045 21.3256 22.8091C21.0665 22.8137 20.8158 22.7175 20.6262 22.5409C20.0187 21.9332 19.2974 21.4512 18.5035 21.1224C17.7097 20.7935 16.8588 20.6243 15.9996 20.6243C15.1403 20.6243 14.2894 20.7935 13.4956 21.1224C12.7017 21.4512 11.9804 21.9332 11.3729 22.5409C11.1833 22.7175 10.9326 22.8137 10.6735 22.8091C10.4145 22.8045 10.1673 22.6996 9.98406 22.5164C9.80085 22.3331 9.6959 22.086 9.69133 21.8269C9.68676 21.5678 9.78292 21.3171 9.95956 21.1275ZM15.9996 24.2902C16.2648 24.2902 16.5191 24.3956 16.7067 24.5831C16.8942 24.7706 16.9996 25.025 16.9996 25.2902V25.9569C16.9996 26.2221 16.8942 26.4764 16.7067 26.664C16.5191 26.8515 16.2648 26.9569 15.9996 26.9569C15.7343 26.9569 15.48 26.8515 15.2925 26.664C15.1049 26.4764 14.9996 26.2221 14.9996 25.9569V25.2902C14.9996 25.025 15.1049 24.7706 15.2925 24.5831C15.48 24.3956 15.7343 24.2902 15.9996 24.2902Z"
        fill="#FFD700"
      />
    </svg>
  );
};

export const Ticket = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 9.62321C3 8.65075 3.38631 7.71812 4.07394 7.03048C4.76158 6.34285 5.69421 5.95654 6.66667 5.95654H25.3333C26.3058 5.95654 27.2384 6.34285 27.9261 7.03048C28.6137 7.71812 29 8.65075 29 9.62321V13.6232C29 13.8884 28.8946 14.1428 28.7071 14.3303C28.5196 14.5179 28.2652 14.6232 28 14.6232C27.558 14.6232 27.134 14.7988 26.8215 15.1114C26.5089 15.4239 26.3333 15.8478 26.3333 16.2899C26.3333 16.7319 26.5089 17.1558 26.8215 17.4684C27.134 17.7809 27.558 17.9565 28 17.9565C28.2652 17.9565 28.5196 18.0619 28.7071 18.2494C28.8946 18.437 29 18.6913 29 18.9565V22.9565C29 23.929 28.6137 24.8616 27.9261 25.5493C27.2384 26.2369 26.3058 26.6232 25.3333 26.6232H6.66667C5.69421 26.6232 4.76158 26.2369 4.07394 25.5493C3.38631 24.8616 3 23.929 3 22.9565V18.9565C3 18.6913 3.10536 18.437 3.29289 18.2494C3.48043 18.0619 3.73478 17.9565 4 17.9565C4.44203 17.9565 4.86595 17.7809 5.17851 17.4684C5.49107 17.1558 5.66667 16.7319 5.66667 16.2899C5.66667 15.8478 5.49107 15.4239 5.17851 15.1114C4.86595 14.7988 4.44203 14.6232 4 14.6232C3.73478 14.6232 3.48043 14.5179 3.29289 14.3303C3.10536 14.1428 3 13.8884 3 13.6232V9.62321ZM17 10.9565C17 10.6913 16.8946 10.437 16.7071 10.2494C16.5196 10.0619 16.2652 9.95654 16 9.95654C15.7348 9.95654 15.4804 10.0619 15.2929 10.2494C15.1054 10.437 15 10.6913 15 10.9565V11.6232C15 11.8884 15.1054 12.1428 15.2929 12.3303C15.4804 12.5179 15.7348 12.6232 16 12.6232C16.2652 12.6232 16.5196 12.5179 16.7071 12.3303C16.8946 12.1428 17 11.8884 17 11.6232V10.9565ZM17 15.9565C17 15.6913 16.8946 15.437 16.7071 15.2494C16.5196 15.0619 16.2652 14.9565 16 14.9565C15.7348 14.9565 15.4804 15.0619 15.2929 15.2494C15.1054 15.437 15 15.6913 15 15.9565V16.6232C15 16.8884 15.1054 17.1428 15.2929 17.3303C15.4804 17.5179 15.7348 17.6232 16 17.6232C16.2652 17.6232 16.5196 17.5179 16.7071 17.3303C16.8946 17.1428 17 16.8884 17 16.6232V15.9565ZM17 20.9565C17 20.6913 16.8946 20.437 16.7071 20.2494C16.5196 20.0619 16.2652 19.9565 16 19.9565C15.7348 19.9565 15.4804 20.0619 15.2929 20.2494C15.1054 20.437 15 20.6913 15 20.9565V21.6232C15 21.8884 15.1054 22.1428 15.2929 22.3303C15.4804 22.5179 15.7348 22.6232 16 22.6232C16.2652 22.6232 16.5196 22.5179 16.7071 22.3303C16.8946 22.1428 17 21.8884 17 21.6232V20.9565Z"
        fill="#FFD700"
      />
    </svg>
  );
};

export const Search = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2618 11.28L13.3152 13.3333M12.6665 7.66666C12.6665 8.99275 12.1397 10.2645 11.202 11.2022C10.2644 12.1399 8.99259 12.6667 7.6665 12.6667C6.34042 12.6667 5.06865 12.1399 4.13097 11.2022C3.19329 10.2645 2.6665 8.99275 2.6665 7.66666C2.6665 6.34058 3.19329 5.06881 4.13097 4.13113C5.06865 3.19345 6.34042 2.66666 7.6665 2.66666C8.99259 2.66666 10.2644 3.19345 11.202 4.13113C12.1397 5.06881 12.6665 6.34058 12.6665 7.66666Z"
        stroke="black"
        strokeOpacity="0.3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
